import CRMauth from "@/services/CRMinitAuth"
import { coursesByLocation } from "@/../tests/unit/__utils__/mock-courses";

const getCoursesBy = query =>
  CRMauth.get(`${process.env.VUE_APP_CRM_API}common/courses/`, {
    params: query
  });

const courseListDetailed = query =>
  CRMauth.get(`${process.env.VUE_APP_CRM_API}common/courses/detailed/`, {
    params: query
  });

const allCourses = query =>
  CRMauth.get(`${process.env.VUE_APP_CRM_API}common/courses/all_courses/`, {
    params: query
  });

// const getCoursesBy = query => coursesByLocation

export default {
  getCoursesBy,
  courseListDetailed,
  allCourses
}